import { slugify } from '@bridebook/toolbox/src';
import { Box } from '@bridebook/ui';
import componentStyles from './info-row.style';

interface IProps {
  title: string;
  amount?: string | number | null;
}

const InfoRow = ({ title, amount }: IProps) => {
  const amountFormat = (item: string | number): string[] =>
    typeof item === 'string' ? item.split(' / ') : [`${item}`];

  const amountSet: string[] = amount ? amountFormat(amount) : [];

  const styles = componentStyles();
  return (
    <Box style={styles.wrapper}>
      <Box style={styles.title}>{title}</Box>
      <Box style={styles.amount}>
        {amountSet.map((item) => (
          <Box key={`info-row-amount-item-${slugify(item)}`}>{item}</Box>
        ))}
      </Box>
    </Box>
  );
};

export default InfoRow;
